
function isProd() {
  try {
    return document.location.hostname.startsWith("forms.");
  } catch {
    return false;
  }
}

const prod = isProd();

function getApiUrl() {

  if (prod) {
    return "https://go.getassist.app";
  }

  if (document.location.hostname.startsWith("test")) {
    return "https://test.getassist.app";
  }

  return "";
}

const config = {
  version: "0.0.1",
  isProd: prod,
  apiVersion: 1,
  langVersion: 1,
  apiUrl: getApiUrl(),
  intercomId: "upeixs3n",
  basename: "/",
  defaultPath: "/dashboard/default",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  pageSize: {
    full: "2560px",
    huge: "1920px",
    large: "1600px",
    medium: "1200px",
    compact: "920px",
    small: "720px",
    tiny: "560px"
  },
};

export default config;

